import { cn } from '../../lib/cn';

export default function EntityTooltip({ entity, position }) {
  if (!entity) return null;

  const yearLabel = (year) => {
    if (year < 0) return `${Math.abs(year)} BCE`;
    return `${year} CE`;
  };

  return (
    <div
      className={cn(
        'fixed z-50 pointer-events-none',
        'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600',
        'rounded-lg shadow-lg px-3 py-2 max-w-xs'
      )}
      style={{
        left: position.x + 12,
        top: position.y - 8,
      }}
    >
      <p className="font-semibold text-sm text-gray-900 dark:text-white">
        {entity.Name || entity.NAME}
      </p>
      {entity.start_year != null && entity.end_year != null && (
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          {yearLabel(entity.start_year)} – {yearLabel(entity.end_year)}
        </p>
      )}
      {entity.Area_km2 && (
        <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">
          {Number(entity.Area_km2).toLocaleString()} km²
        </p>
      )}
    </div>
  );
}
